$(document).ready(() => {
	$('.js__reviews__slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: false,
		prevArrow: '<button type="button" aria-label="Предыдущий слайд" class="reviews__slider-arrow reviews__slider-arrow--prev"><svg class="icon "><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/sprite.svg#arrow-left"></use></svg></button>',
		nextArrow: '<button type="button" aria-label="Следующий слайд" class="reviews__slider-arrow reviews__slider-arrow--next"><svg class="icon "><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/img/sprite.svg#arrow-right"></use></svg></button>',
		responsive: [
			{
				breakpoint: 760,
				settings: {
					slidesToShow: 1.2,
				}
			},
			{
				breakpoint: 460,
				settings: {
					slidesToShow: 1,
				}
			},
		]
	});
})
